import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Logo from "../../elements/logo/Logo";
import footerOne from "../../data/footer/footerOne.json";
import ScrollTop from "./ScrollTop";
import { FiFacebook, FiInstagram, FiLinkedin, FiTwitter, FiYoutube } from 'react-icons/fi';
import PaymentSuccess from './../../pages/others/OrderSuccess';

const footerIntem = footerOne[0];
const footerIntemOne = footerOne[1];
const footerIntemTwo = footerOne[2];
const footerIntemThree = footerOne[3];
const footerIntemFour = footerOne[4];
const footerIntemFive = footerOne[5];
const indexOneLink = footerIntemOne.quicklink;
const indexTwoLink = footerIntemTwo.quicklink;
const indexThreeLink = footerIntemThree.quicklink;

const FooterOne = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError(false);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/subscribers`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('Thank you for subscribing!');
                setEmail('');
            } else {
                setError(true);
                setMessage(data?.message || 'Subscription failed. Try again.');
            }
        } catch (err) {
            setError(true);
            setMessage('Something went wrong. Please try again.');
        }
    };

    return (
        <>
            <footer className="rn-footer footer-style-default">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            {/* Logo & Social */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <div className="logo">
                                        <Logo 
                                            image={`${process.env.PUBLIC_URL}/images/logo/logo.png`}
                                            image2={`${process.env.PUBLIC_URL}/images/logo/logo-dark.png`}
                                        />
                                    </div>
                                    <h3 className="text-big">{footerIntem.title}</h3>
                                    <div className="row mt--30">
                                        <div className="col-lg-12">
                                            <ul className="social-icon social-default with-gradient d-flex justify-content-start">
                                                <li><a target='BLANK' href="https://www.facebook.com/share/16qKp424qd/?mibextid=wwXIfr"><FiFacebook /></a></li>
                                                <li><a target='BLANK' href="https://youtube.com/@passionateworld8122?si=-0yD6TMI4oaR6NJQ"><FiYoutube /></a></li>
                                                {/* <li><Link to="instagram.com"><FiInstagram /></Link></li> */}
                                                <li><a target='BLANK' href="https://www.linkedin.com/in/jahid-hasan-5932131b8/"><FiLinkedin /></a></li>
                                            </ul>
                                        </div>
                                        <div className='pt-3'>
                                            <p>Pakuria Uttarpara, Poba, Rajshahi , Bangladesh, Poba<br />
                                            PS, Rajshahi-6212, Bangladesh</p>
                                            <p><strong>Trade Licence: </strong>00112</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Quick Links */}
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <div className="widget-menu-top">
                                        <h4 className="title">{footerIntemOne.title}</h4>
                                        <div className="inner">
                                            <ul className="footer-link link-hover">
                                                {indexOneLink.map((data, index) => (
                                                    <li key={index}><Link to={data.url}>{data.text}</Link></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <div className="widget-menu-top">
                                        <h4 className="title">{footerIntemThree.title}</h4>
                                        <div className="inner">
                                            <ul className="footer-link link-hover">
                                                {indexTwoLink.map((data, index) => (
                                                    <li key={index}><Link to={data.url}>{data.text}</Link></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Newsletter Form */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{footerIntemFive.title}</h4>
                                    <div className="inner">
                                        <h6 className="subtitle">{footerIntemFive.subtitle}</h6>
                                        <form className="newsletter-form" onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <input 
                                                    type="email" 
                                                    placeholder="Enter Your Email Here" 
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <button className="btn-default" type="submit">Submit Now</button>
                                            </div>
                                            {message && (
                                                <p style={{ color: error ? 'red' : 'green' }}>{message}</p>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <ScrollTop />
        </>
    )
};

export default FooterOne;
